"use client";
import React from "react";
import Image from "next/image";
import { FaChartLine } from "react-icons/fa";
import useTranslation from "@/hook/useTranslation";
import { HiOutlineArrowRight } from "react-icons/hi";
import { useRouter } from "next/navigation";
import TopNewsSidebar from "@/components/TopNewsSidebar";

const WhatWeOffer = ({ news = [] }) => {
  const { t, locale } = useTranslation();
  const router = useRouter();
  const services = [
    {
      id: 1,
      title: t("whatWeOfferContentTitle1"),
      description: t("whatWeOfferContentDescription1"),
      image: "/images/service-1.jpg",
    },
    {
      id: 2,
      title: t("whatWeOfferContentTitle2"),
      description: t("whatWeOfferContentDescription2"),
      image: "/images/service-2.jpg",
    },
    {
      id: 3,
      title: t("whatWeOfferContentTitle6"),
      image: "/images/service-3.jpg",
    },
    {
      id: 4,
      title: t("whatWeOfferContentTitle7"),
      image: "/images/service-3.jpg",
    },
  ];

  return (
    <section className="py-16 px-4 md:px-12 bg-white whatweoffers">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
        {/* Left: Services (2/3) */}
        <div className="lg:col-span-2 left-grid">
          <div className="text-center">
            <p className="text-green-500 uppercase tracking-widest font-semibold inline-flex items-center space-x-2 justify-center">
              <FaChartLine className="h-5 w-5 headline" />
              <span>{t("whatWeOffer")}</span>
            </p>
            <h1 className="text-4xl md:text-5xl font-bold mt-4 text-black leading-tight heading1">
              {t("whatWeOfferTitle")} <br className="hidden md:block" />{" "}
              {t("whatWeOfferTitle2")}
            </h1>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-10">
            {services.map((service) => {
              const { id, title, description, image, dark } = service;

              return (
                <div
                  key={id}
                  className={`service-block-one ${
                    dark ? "bg-white text-white" : "bg-white"
                  }`}
                >
                  {image && (
                    <Image
                      src={image}
                      alt={title}
                      width={500}
                      height={300}
                      className="w-full h-48 md:h-48 object-cover"
                    />
                  )}
                  <div className="p-6">
                    <h3 className="text-md font-semibold uppercase text-gray-400 mb-1 service">
                      {t("service")} #{id}
                    </h3>
                    <h4 className="text-xl font-bold mb-2 title">{title}</h4>
                    <p className="text-sm mb-4 description text-gray-500">
                      {description}
                    </p>
                    <button
                      className="service-button flex items-center px-5 py-2 border border-gray-300 rounded-full bg-white text-black hover:bg-gray-100 transition"
                      onClick={() => {
                        router.push(`/${locale}/news`);
                      }}
                    >
                      <HiOutlineArrowRight className="mr-2 text-lg" />
                      <span className="font-medium">Explore</span>
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Right: Sidebar News */}
        <div className="w-full">
          <TopNewsSidebar news={news} />
        </div>
      </div>
    </section>
  );
};

export default WhatWeOffer;
